import { useEffect } from 'react';

import { useAuthToken } from './useAuthToken';
import { getAndClearRedirectUrl } from '@/utils/auth';

// gloss
export function useRedirectOnLogin() {
  const { isAuthenticated } = useAuthToken();

  useEffect(() => {
    if (!isAuthenticated) return;

    const redirectUrl = getAndClearRedirectUrl();
    if (redirectUrl && typeof window !== 'undefined') {
      window.location.href = redirectUrl;
    }
  }, [isAuthenticated]);
}

export default useRedirectOnLogin;
